import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {EstoqueService} from "../../services/estoque.service";
import {UnidadeMedidaUtils} from "../UnidadeMedidaUtils";
import {PrevisaoFinanceiraMovimentacao} from "./PrevisaoFinanceiraMovimentacao";
import {ConversaoApresentacaoEntrada} from "./ConversaoApresentacaoEntrada";

@Component({
  selector: 'app-form-movimentacao-insumo',
  templateUrl: './form-movimentacao-insumo.component.html',
  styleUrls: ['./form-movimentacao-insumo.component.scss']
})
export class FormMovimentacaoInsumoComponent implements OnInit, OnDestroy {
  @Input() varios  = false;
  @Input() movimentacao: any = {};
  @Output() onSalvou: any =   new EventEmitter();
  @Output() onCancelou: any =   new EventEmitter();
  @ViewChild('frmM', {static: false}) frmM: NgForm;
  salvando = false;
  movimentacoes: any = [];
  mensagemErro: string;
  motivosMovimentacao   = [ ]
  tipoSelecionado: 'entrada' | 'saida' = null;
  controleCustoEstoqueAtivo = false;
  carregandoStatusControleCusto = true;
  resultadoBeneficiamento: any;
  previaBeneficiamento: any;
  carregandoPreviaBeneficiamento = false;
  erroPreviaBeneficiamento: any;
  exibindoResumoBeneficiamento = false;
  private versaoPreviaBeneficiamento = 0;
  constructor(private estoqueService: EstoqueService) { }

  ngOnInit(): void {
    delete this.mensagemErro;
    this.salvando = false;
    this.movimentacao.horario = new Date();
    this.tipoSelecionado = this.movimentacao.motivoDaMovimentacao
      ? this.movimentacao.motivoDaMovimentacao.tipo
      : null;
    if(this.varios)
      this.movimentacoes.push({ insumo: null, quantidade: null})
    else if(this.movimentacao.insumo)
      this.carregueApresentacoes(this.movimentacao);

    this.estoqueService.obtenhaStatusControleCustoEstoque().then((status: any) => {
      this.controleCustoEstoqueAtivo = !!status.ativo;
      this.carregandoStatusControleCusto = false;
    }).catch((erro: any) => {
      this.carregandoStatusControleCusto = false;
      this.mensagemErro = erro;
    });

    this.estoqueService.listeMotivosMotimentacoes( ).then( (resposta: any) => {
      this.motivosMovimentacao = resposta;
      const motivoId = Number(this.movimentacao.motivoDaMovimentacao?.id);
      const motivoSelecionado = this.motivosMovimentacao.find(
        (motivo: any) => Number(motivo.id) === motivoId
      );
      if(motivoSelecionado){
        this.movimentacao.motivoDaMovimentacao = motivoSelecionado;
        this.tipoSelecionado = motivoSelecionado.tipo;
      }
    });

    this.configureEscalaDoBeneficiamento();

  }

  ngOnDestroy(): void {
    this.versaoPreviaBeneficiamento++;
  }

  obtenhaMotivos( ){
    let beneficado = this.movimentacao.insumo  && this.movimentacao.insumo.tipo === 'produto-beneficiado';

    if(this.varios || beneficado ) return  this.motivosMovimentacao;

    return  this.motivosMovimentacao.filter((item: any) => !item.paraInsumoBeneficado)

  }

  motivosDoTipo(): any[] {
    if(!this.tipoSelecionado)
      return [];
    return this.obtenhaMotivos().filter(
      (item: any) => item.tipo === this.tipoSelecionado
    );
  }

  iconeDoMotivo(motivo: any): string {
    const iconesPorMotivo: any = {
      3: 'fas fa-industry',
      4: 'fas fa-clipboard',
      5: 'fas fa-clipboard',
      6: 'fas fa-sliders-h',
      7: 'fas fa-sliders-h',
      8: 'fas fa-exclamation-triangle'
    };
    return iconesPorMotivo[Number(motivo && motivo.id)] || 'fas fa-exchange-alt';
  }

  alterouTipo(tipo: 'entrada' | 'saida'): void {
    this.exibindoResumoBeneficiamento = false;
    this.tipoSelecionado = tipo;
    delete this.movimentacao.motivoDaMovimentacao;
    delete this.movimentacao.justificativa;
    this.limpeDadosDependentesDoMotivo();
    if(tipo !== 'entrada')
      this.itensDaMovimentacao().forEach(item => this.limpeApresentacao(item));
  }


  alterouMotivo(motivoDaMovimentacao: any) {
    this.exibindoResumoBeneficiamento = false;
    this.movimentacao.motivoDaMovimentacao = motivoDaMovimentacao;
    this.limpeDadosDependentesDoMotivo();
    if(motivoDaMovimentacao.tipo !== 'entrada' || this.entradaPorBenefiamento())
      this.itensDaMovimentacao().forEach(item => this.limpeApresentacao(item));
    if(!this.exigeJustificativa())
      delete this.movimentacao.justificativa;
    this.configureEscalaDoBeneficiamento();
    if(this.varios){
      if(motivoDaMovimentacao.paraInsumoBeneficado){
        this.movimentacoes.forEach((item: any) => {
           if(item.insumo && item.insumo.tipo !== 'produto-beneficiado'){
             item.insumo = null
           }
        })
      }
    }
  }

  entradaPorBenefiamento(){
    return Number(this.movimentacao.motivoDaMovimentacao?.id) === 3
  }

  onSalvarMovimentacao(){
    if(this.entradaPorBenefiamento() && !this.exibindoResumoBeneficiamento){
      this.irParaResumoDaProducao();
      return;
    }
    if(this.entradaPorBenefiamento() &&
       (!this.previaBeneficiamento || this.previaBeneficiamento.podeConfirmar !== true))
      return;

    if(this.frmM.valid){
      this.salvando = true;

      if(this.varios){
        let dados: any = Object.assign({}, this.movimentacao)
        dados.insumos = this.movimentacoes.map(item => this.prepareItemParaEnvio(item));

        this.estoqueService.registreMovimentacoesManual(dados).then((resposta) => {
          this.salvando = false;
          this.onSalvou.emit( )
        }).catch((err) => {
          this.mensagemErro = err
          this.salvando = false;
        })
      } else {
        const dados = this.prepareItemParaEnvio(this.movimentacao);
        this.estoqueService.registreMovimentacaoManual(dados).then((resposta: any) => {
          this.movimentacao.insumo.estoque =      resposta.insumo.estoque
          if(this.entradaPorBenefiamento())
            this.resultadoBeneficiamento = resposta;
          this.salvando = false;
          this.onSalvou.emit(this.movimentacao)
        }).catch((err) => {
          this.mensagemErro = err
          this.salvando = false;
        })
      }
    }
  }

  irParaResumoDaProducao(): void {
    if(!this.entradaPorBenefiamento() || !this.frmM || !this.frmM.valid ||
       this.carregandoPreviaBeneficiamento || this.possuiErroApresentacao())
      return;
    this.calculeResumoDaProducao();
  }

  volteDoResumoDaProducao(): void {
    this.exibindoResumoBeneficiamento = false;
    delete this.previaBeneficiamento;
    delete this.erroPreviaBeneficiamento;
  }


  canceleMovimentacao(){
    this.onCancelou.emit({})
  }


  obtenhaFormato(){
    return this.obtenhaFormatoDoInsumo(this.movimentacao.insumo)
  }

  obtenhaFormatoDoInsumo(insumo: any){
    return UnidadeMedidaUtils.obtenhaFormatoItem(insumo)
  }

  obtenhaDescricaoUnidade(insumo: any){
    return UnidadeMedidaUtils.obtenhaDescricaoUnidade(insumo)
  }

  novaMovimentacao() {
    this.movimentacoes.push(this.entradaPorBenefiamento() ? {quantidadeReceitas: 1} : {})
  }

  removaMovimentacao(i: number) {
    this.movimentacoes.splice(i, 1);
  }

  alterouInsumoDaMovimentacao(item?: any): void {
    if(item){
      if(this.entradaPorBenefiamento() &&
         !(this.numeroDoFormulario(item.quantidadeReceitas) > 0))
        item.quantidadeReceitas = 1;
      this.limpeApresentacao(item);
      this.carregueApresentacoes(item);
    }
  }

  deveOferecerApresentacao(item: any): boolean {
    const insumo = item && item.insumo;
    return this.tipoMovimentacao() === 'entrada' && !this.entradaPorBenefiamento() &&
      !!insumo && !!insumo.id && insumo.objeto !== 'ficha-tecnica';
  }

  temApresentacoes(item: any): boolean {
    return this.deveOferecerApresentacao(item) &&
      (item._carregandoApresentacoes || item._erroApresentacoes ||
        Array.isArray(item._apresentacoesCompra) && item._apresentacoesCompra.length > 0);
  }

  apresentacoesDoItem(item: any): any[] {
    return item && item._apresentacoesCompra || [];
  }

  apresentacaoSelecionada(item: any): boolean {
    return !!(item && item.apresentacaoCompraInsumo && item.apresentacaoCompraInsumo.id);
  }

  alterouApresentacao(item: any, apresentacao: any): void {
    item.apresentacaoCompraInsumo = apresentacao && apresentacao.id ? apresentacao : null;
    delete item.quantidade;
    delete item.quantidadeApresentacao;
    delete item._erroConversaoApresentacao;
    this.limpeCustos(item);
  }

  alterouQuantidadeApresentacao(item: any, valor: number): void {
    item.quantidadeApresentacao = valor;
    item._erroConversaoApresentacao = ConversaoApresentacaoEntrada.atualizeQuantidadeBase(item);
    this.sincronizeCustoDepoisDaConversao(item);
  }

  descricaoConversao(item: any): string {
    if(!this.apresentacaoSelecionada(item) || !(Number(item.quantidade) > 0))
      return 'Informe a quantidade para visualizar a conversão.';
    const sigla = item.insumo && item.insumo.unidadeMedida && item.insumo.unidadeMedida.sigla || '';
    return `${this.formateNumeroApresentacao(item.quantidadeApresentacao, 6)} × ` +
      `${this.formateNumeroApresentacao(item.apresentacaoCompraInsumo.apresentacaoCompra.fatorConversao, 6)} = ` +
      `${this.formateNumeroApresentacao(item.quantidade, 3)} ${sigla}`;
  }

  tipoMovimentacao(): string {
    return this.movimentacao.motivoDaMovimentacao && this.movimentacao.motivoDaMovimentacao.tipo;
  }

  entradaComCustoInformado(): boolean {
    return this.controleCustoEstoqueAtivo && this.tipoMovimentacao() === 'entrada' &&
      !this.entradaPorBenefiamento();
  }

  saidaComCustoCalculado(): boolean {
    return this.controleCustoEstoqueAtivo &&
      (this.tipoMovimentacao() === 'saida' || this.tipoMovimentacao() === 'devolucao');
  }

  exigeJustificativa(): boolean {
    const id = Number(this.movimentacao.motivoDaMovimentacao && this.movimentacao.motivoDaMovimentacao.id);
    return this.controleCustoEstoqueAtivo && [6, 7, 8].indexOf(id) >= 0;
  }

  alterouQuantidade(item: any, valor: number): void {
    item.quantidade = valor;
    if(item._fonteCusto === 'total' && item.custoTotal != null)
      PrevisaoFinanceiraMovimentacao.sincronizePorTotal(item, item.custoTotal);
    else if(item.custoUnitario != null)
      PrevisaoFinanceiraMovimentacao.sincronizePorUnitario(item, item.custoUnitario);
  }

  alterouQuantidadeReceitas(item: any, valor: number): void {
    item.quantidadeReceitas = valor;
  }

  rendimentoEsperadoDoItem(item: any): number | null {
    const itemDaPrevia = this.itemDaPreviaBeneficiamento(item);
    const quantidadeEsperadaDaPrevia = this.numeroDoFormulario(
      itemDaPrevia && itemDaPrevia.quantidadeEsperada
    );
    if(quantidadeEsperadaDaPrevia >= 0)
      return quantidadeEsperadaDaPrevia;

    const rendimento = this.numeroDoFormulario(
      item && item.insumo && item.insumo.receita && item.insumo.receita.rendimento
    );
    const quantidadeReceitas = this.numeroDoFormulario(item && item.quantidadeReceitas);
    if(!(rendimento > 0) || !(quantidadeReceitas > 0))
      return null;
    return Number((rendimento * quantidadeReceitas).toFixed(3));
  }

  receitasPreparadasDaPrevia(item: any): number | null {
    const quantidadeDaPrevia = this.numeroDoFormulario(item && item.quantidadeReceitas);
    if(quantidadeDaPrevia > 0)
      return quantidadeDaPrevia;
    const itemDaTela = this.itemDaTelaPorIdInsumo(item && item.idInsumo);
    const quantidadeDaTela = this.numeroDoFormulario(itemDaTela && itemDaTela.quantidadeReceitas);
    return quantidadeDaTela > 0 ? quantidadeDaTela : null;
  }

  rendimentoEsperadoDaPrevia(item: any): number | null {
    const quantidadeDaPrevia = this.numeroDoFormulario(item && item.quantidadeEsperada);
    if(quantidadeDaPrevia >= 0)
      return quantidadeDaPrevia;
    return this.rendimentoEsperadoDoItem(this.itemDaTelaPorIdInsumo(item && item.idInsumo));
  }

  alterouCustoUnitario(item: any, valor: number): void {
    PrevisaoFinanceiraMovimentacao.sincronizePorUnitario(item, valor);
  }

  alterouCustoTotal(item: any, valor: number): void {
    PrevisaoFinanceiraMovimentacao.sincronizePorTotal(item, valor);
  }

  alterouCustoApresentacao(item: any, valor: number): void {
    PrevisaoFinanceiraMovimentacao.sincronizePorApresentacao(item, valor);
  }

  descricaoCustoApresentacao(item: any): string {
    const descricao = item && item.apresentacaoCompraInsumo &&
      item.apresentacaoCompraInsumo.apresentacaoCompra &&
      item.apresentacaoCompraInsumo.apresentacaoCompra.descricao;
    return descricao ? `Custo por ${descricao}` : 'Custo da unidade de compra';
  }

  custoTotalPrevisto(item: any): number | null {
    return PrevisaoFinanceiraMovimentacao.custoTotalPrevisto(
      item,
      this.tipoMovimentacao(),
      this.entradaPorBenefiamento()
    );
  }

  custoMedioAtual(item: any): number | null {
    const estoque = item && item.insumo && item.insumo.estoque;
    return !estoque || estoque.custoMedio == null ? null : Number(estoque.custoMedio);
  }

  custoDesconhecido(item: any): boolean {
    return this.saidaComCustoCalculado() && this.custoMedioAtual(item) === null;
  }

  possuiErroApresentacao(): boolean {
    return this.itensDaMovimentacao().some(item =>
      !!item._erroConversaoApresentacao ||
      this.apresentacaoSelecionada(item) && !(Number(item.quantidade) > 0)
    );
  }

  private limpeDadosDependentesDoMotivo(): void {
    this.exibindoResumoBeneficiamento = false;
    this.itensDaMovimentacao().forEach((item: any) => this.limpeCustos(item));
    delete this.resultadoBeneficiamento;
    delete this.previaBeneficiamento;
    delete this.erroPreviaBeneficiamento;
  }

  private configureEscalaDoBeneficiamento(): void {
    this.itensDaMovimentacao().forEach((item: any) => {
      if(this.entradaPorBenefiamento()){
        if(!(this.numeroDoFormulario(item.quantidadeReceitas) > 0))
          item.quantidadeReceitas = 1;
      } else {
        delete item.quantidadeReceitas;
      }
    });
  }

  private carregueApresentacoes(item: any): void {
    const idInsumo = Number(item && item.insumo && item.insumo.id);
    if(!idInsumo || item.insumo.objeto === 'ficha-tecnica')
      return;
    item._carregandoApresentacoes = true;
    delete item._erroApresentacoes;
    this.estoqueService.listeApresentacoesCompra(idInsumo).then((apresentacoes: any[]) => {
      if(Number(item.insumo && item.insumo.id) !== idInsumo)
        return;
      item._apresentacoesCompra = (apresentacoes || [])
        .filter(apresentacao => !!apresentacao.ativa &&
          !!(apresentacao.apresentacaoCompra && apresentacao.apresentacaoCompra.ativa))
        .map(apresentacao => Object.assign({}, apresentacao, {
          _descricaoApresentacao: apresentacao.apresentacaoCompra.descricao
        }));
      item._carregandoApresentacoes = false;
      const padrao = item._apresentacoesCompra.find(apresentacao => !!apresentacao.padrao);
      if(padrao && !item.apresentacaoCompraInsumo)
        this.alterouApresentacao(item, padrao);
    }).catch((erro: any) => {
      if(Number(item.insumo && item.insumo.id) !== idInsumo)
        return;
      item._carregandoApresentacoes = false;
      item._erroApresentacoes = erro;
    });
  }

  private limpeApresentacao(item: any): void {
    if(!item)
      return;
    delete item.apresentacaoCompraInsumo;
    delete item.quantidadeApresentacao;
    delete item._erroConversaoApresentacao;
    this.limpeCustos(item);
  }

  private sincronizeCustoDepoisDaConversao(item: any): void {
    if(item._fonteCusto === 'apresentacao' && item.custoApresentacao != null)
      PrevisaoFinanceiraMovimentacao.sincronizePorApresentacao(item, item.custoApresentacao);
    else if(item._fonteCusto === 'total' && item.custoTotal != null)
      PrevisaoFinanceiraMovimentacao.sincronizePorTotal(item, item.custoTotal);
    else if(item.custoUnitario != null)
      PrevisaoFinanceiraMovimentacao.sincronizePorUnitario(item, item.custoUnitario);
  }

  private limpeCustos(item: any): void {
    delete item.custoApresentacao;
    delete item.custoUnitario;
    delete item.custoTotal;
    delete item._fonteCusto;
  }

  private formateNumeroApresentacao(valor: any, casas: number): string {
    const numero = Number(valor);
    return Number.isFinite(numero)
      ? numero.toLocaleString('pt-BR', {maximumFractionDigits: casas})
      : '';
  }

  private calculeResumoDaProducao(): void {
    this.versaoPreviaBeneficiamento++;
    const versao = this.versaoPreviaBeneficiamento;

    delete this.previaBeneficiamento;
    delete this.erroPreviaBeneficiamento;
    this.carregandoPreviaBeneficiamento = false;

    const itens = this.itensParaPreviaBeneficiamento();
    if(!itens)
      return;

    this.carregandoPreviaBeneficiamento = true;
    this.estoqueService.prevejaBeneficiamento(itens).then((previa: any) => {
      if(versao !== this.versaoPreviaBeneficiamento)
        return;
      const itensDaTela = this.itensDaMovimentacao();
      previa.itens.forEach((item: any) => {
        const itemDaTela = itensDaTela.find(
          (movimentacao: any) => Number(movimentacao.insumo.id) === Number(item.idInsumo)
        );
        item.insumo = itemDaTela && itemDaTela.insumo;
      });
      this.previaBeneficiamento = previa;
      this.carregandoPreviaBeneficiamento = false;
      this.exibindoResumoBeneficiamento = true;
    }).catch((erro: any) => {
      if(versao !== this.versaoPreviaBeneficiamento)
        return;
      this.erroPreviaBeneficiamento = erro;
      this.carregandoPreviaBeneficiamento = false;
    });
  }

  private itensParaPreviaBeneficiamento(): any[] | null {
    if(!this.entradaPorBenefiamento())
      return null;
    const itens = this.itensDaMovimentacao();
    if(!itens.length || itens.some((item: any) =>
      !item.insumo || !item.insumo.id || !(this.numeroDoFormulario(item.quantidade) > 0) ||
      !(this.numeroDoFormulario(item.quantidadeReceitas) > 0)))
      return null;
    return itens.map((item: any) => ({
      insumo: {id: item.insumo.id},
      quantidade: this.numeroDoFormulario(item.quantidade),
      quantidadeReceitas: this.numeroDoFormulario(item.quantidadeReceitas)
    }));
  }

  private numeroDoFormulario(valor: any): number {
    if(typeof valor === 'number')
      return valor;
    if(typeof valor !== 'string' || !valor.trim())
      return Number.NaN;
    const texto = valor.trim();
    return Number(texto.indexOf(',') >= 0
      ? texto.replace(/\./g, '').replace(',', '.')
      : texto);
  }

  private itensDaMovimentacao(): any[] {
    return this.varios ? this.movimentacoes : [this.movimentacao];
  }

  private itemDaPreviaBeneficiamento(item: any): any {
    if(!this.previaBeneficiamento || !Array.isArray(this.previaBeneficiamento.itens))
      return null;
    const idInsumo = Number(item && item.insumo && item.insumo.id);
    return this.previaBeneficiamento.itens.find(
      (itemDaPrevia: any) => Number(itemDaPrevia.idInsumo) === idInsumo
    );
  }

  private itemDaTelaPorIdInsumo(idInsumo: any): any {
    return this.itensDaMovimentacao().find(
      (item: any) => Number(item && item.insumo && item.insumo.id) === Number(idInsumo)
    );
  }

  private prepareItemParaEnvio(item: any): any {
    const seguro = PrevisaoFinanceiraMovimentacao.prepareItemParaEnvio(
      item,
      this.tipoMovimentacao(),
      this.entradaPorBenefiamento()
    );
    if(this.entradaPorBenefiamento()){
      seguro.quantidade = this.numeroDoFormulario(item.quantidade);
      seguro.quantidadeReceitas = this.numeroDoFormulario(item.quantidadeReceitas);
    }
    return seguro;
  }
}
